__webpack_require__.p = "https://assets-01.periodica.press/77cfeec-20574684312/";